import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import styles from './PatientItem.module.css';

/** Iniciais para o avatar ("Maria Souza" → "MS"). */
export function getInitials(name) {
  return (name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}

/**
 * Linha de paciente usada em todas as listas do Início: avatar com iniciais,
 * nome (abre a ficha), uma linha de detalhe e as ações à direita.
 * `leading` entra antes do avatar (ex.: horário); `sent` esmaece a linha e
 * mostra o selo de mensagem enviada (`sentTitle` troca o texto do selo, ex.:
 * quando a mensagem só foi aberta no WhatsApp Web). Sem ficha (ex.: reserva
 * por telefone), `avatar` troca as iniciais por um ícone e
 * `onNameClick`/`nameTitle` trocam o destino do nome.
 */
function PatientItem({
  name, patientId, meta, leading, actions, sent = false, sentTitle = 'Mensagem enviada', tone = 'blue',
  avatar, onNameClick, nameTitle = 'Abrir ficha do paciente',
}) {
  const openPatient = () => {
    if (onNameClick) onNameClick();
    else if (patientId) window.open(`/patients/${patientId}`);
  };

  return (
    <div className={`${styles.item} ${sent ? styles.sent : ''}`}>
      {leading}
      <span className={`${styles.avatar} ${styles[tone] || ''}`} aria-hidden="true">
        {avatar || getInitials(name)}
      </span>
      <div className={styles.info}>
        <div className={styles.nameRow}>
          <button type="button" className={styles.name} onClick={openPatient} title={nameTitle}>
            {name}
          </button>
          {sent && (
            <span className={styles.sentBadge} title={sentTitle}>
              <CheckIcon style={{ fontSize: 11 }} />
            </span>
          )}
        </div>
        {meta && <span className={styles.meta}>{meta}</span>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}

export default PatientItem;
